import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import addGeometryAndNamedValuesState from "utils/addGeometryAndNamedValuesState";
import getFieldDomain from "utils/getDomain";

export default async function getEsriData({
  view,
  token,
  table,
  neededDomains,
  query,
  outFields,
  externalDomains,
}) {
  const url = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${
    process.env.REACT_APP_FZ_Tables_N
  }/FeatureServer/${table}?${token ? `&token=${token}` : ""}`;
  const domainUrl = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${
    process.env.REACT_APP_FZ_Tables_N
  }/FeatureServer/${table}?f=pjson${token ? `&token=${token}` : ""}`;

  const serverFeatureLayer = new FeatureLayer({
    url,
  });
  // let domains;
  // let fields;
  const neededDomainsObject = {};
  neededDomains?.forEach((domain) => {
    neededDomainsObject[domain] = domain;
  });
  const { domains: resultDomains, fields: resultFields } = await getFieldDomain(
    neededDomains,
    true,
    domainUrl
  );
  const domains = externalDomains || resultDomains;
  const fields = resultFields;

  const serverFeatureLayerQuery = await serverFeatureLayer.queryFeatures({
    where: query || `1=1`,
    outFields: outFields || "*",
    returnGeometry: true,
    outSpatialReference: view?.spatialReference,
  });
  const res = addGeometryAndNamedValuesState(
    serverFeatureLayerQuery.features,
    domains
  );
  return {
    domains,
    fields,
    res,
    serverFeatureLayer,
    serverFeatureLayerQuery,
  };
}
